import { EBookType, EMarpolBookId, IBook } from "./types";

const vesselConstants = {
	feature: "@vessel",
	forms: {},
};

export enum TAB_IDS {
	myVessels = "my-vessels",
	all = "all"
}

export default vesselConstants;
